export default "__VITE_ASSET__4GCn1Lca__"